export default __webpack_public_path__ + "static/EDUbox_cut_no_tag@2x-686c5ebee87136757759a647b46c28e2.jpg";